export default __webpack_public_path__ + "static/media/empty-state.b9bc717b.png";